/* ET - Cart Testimonials — Swiper init (two-up review cards, arrows + pill progress indicator)

   Swiper ships with the theme as et-swiper.min.js, loaded just before this file, so both are deferred and execute
   in document order. Init is scoped per section root, which is what lets this section coexist with the other ET
   sliders on the same page and drive only its own arrows and progress pill. */

(function () {
  'use strict';

  if (window.__etCartTestimonialsInit) return;
  window.__etCartTestimonialsInit = true;

  /* In the theme editor a section can be injected after the deferred bundle has already run, and on a cold first
     paint the bundle may not have executed yet — cover both without assuming an order. */
  function whenSwiperReady(cb) {
    if (window.Swiper) {
      cb();
      return;
    }

    var vendor = document.querySelector('script[src*="et-swiper.min.js"]');
    if (vendor) {
      vendor.addEventListener('load', cb, { once: true });
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function buildOptions(root, el) {
    /* Swiper's a11y module overwrites the arrows' server-rendered aria-label at afterInit with its own defaults, and
       those defaults are hard-coded English ("Previous slide" / "Next slide") — on a Dutch storefront the section's
       `| t` output is silently discarded. The section emits the translated strings on the swiper element so they can
       be fed back in here. Same strings drive Swiper's live-region announcement on keyboard navigation, so this also
       covers mobile, where the arrows are hidden and arrow keys are the only way through the slider. */
    var a11y = { enabled: true };
    if (el.dataset.etCtPrevLabel) a11y.prevSlideMessage = el.dataset.etCtPrevLabel;
    if (el.dataset.etCtNextLabel) a11y.nextSlideMessage = el.dataset.etCtNextLabel;

    return {
      /* 'auto' hands the card width to CSS (min(419px, 100%)) instead of deriving it from the track. The track is
         NOT a fixed 858px: from 990px up assets/et-cart-shared.css turns #main into a grid and gives this section a
         `minmax(0, 858px)` column, so the track shrinks with the viewport and only reaches 858px above ~1392px —
         about 589px at 990px and 611px at 1024px. A fixed slidesPerView: 2 draws ~286px cards there, and the header
         row's unshrinkable 146px (5 star tiles + score + gaps) then leaves the reviewer name ~82px and wraps it.
         Sizing the slide instead degrades to one card plus a peek and keeps the card at its drawn width. */
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 450,
      grabCursor: true,
      watchOverflow: true,
      threshold: 4,
      observer: true,
      observeParents: true,
      a11y: a11y,

      /* The arrows are display:none below 750px by design, and the review cards contain no focusable content, so
         without this a keyboard-only user on a phone (or at 400% zoom on a laptop) can neither see nor reach reviews
         2..N - the track is overflow:hidden. The module ships in the bundle but defaults to enabled:false. Paired
         with tabindex="0" on the swiper element in the section, arrow keys move the slider once it has focus. */
      /* Started DISABLED and turned on only while focus is inside the slider - see init(). Swiper's keyboard
         module attaches its keydown listener to the DOCUMENT and gates it on the slider merely being in the
         viewport, not on focus, then calls preventDefault() on PageUp/PageDown/Left/Right. Shipping
         `enabled: true` therefore stops PageDown scrolling the cart page for every keyboard user as soon as any
         corner of this slider is on screen. pageUpDown stays false as a second guard, so the page's primary scroll
         keys are never swallowed even while the slider does have focus. */
      keyboard: { enabled: false, onlyInViewport: true, pageUpDown: false },
      navigation: {
        prevEl: root.querySelector('[data-et-ct-prev]'),
        nextEl: root.querySelector('[data-et-ct-next]')
      },
      /* Scrollbar rather than progressbar pagination: a progressbar fill is sized with transform: scaleX(), which
         flattens its border-radius, while the scrollbar drag is sized in pixels and keeps the drawn pill shape. */
      scrollbar: {
        el: root.querySelector('[data-et-ct-scrollbar]'),
        draggable: true,
        /* The mobile frame draws a fixed 48px thumb in the 111px track. Left on 'auto' Swiper derives it from
           visibleWidth/virtualSize, which lands near 27px with the four shipped reviews and drifts every time a
           merchant adds or removes one. Desktop keeps 'auto': that pill is a different component (140x19 track,
           7px thumb) where the proportional size is correct. */
        dragSize: window.matchMedia('(max-width: 749px)').matches ? 48 : 'auto',
        hide: false
      }
    };
  }

  function init(root) {
    var el = root.querySelector('[data-et-ct-swiper]');
    if (!el || el.dataset.etInit === 'true') return;
    el.dataset.etInit = 'true';

    whenSwiperReady(function () {
      root.etSwiper = new window.Swiper(el, buildOptions(root, el));

      /* Arrow keys move the slider only while focus is inside it. That is what makes the tabindex="0" region
         genuinely operable (the arrows are display:none below 750px) without the module's document-wide binding
         hijacking scroll for the rest of the page. */
      el.addEventListener('focusin', function () {
        if (root.etSwiper && root.etSwiper.keyboard) root.etSwiper.keyboard.enable();
      });
      el.addEventListener('focusout', function () {
        if (root.etSwiper && root.etSwiper.keyboard) root.etSwiper.keyboard.disable();
      });
    });
  }

  /* The section wrapper itself carries .et-cart-testimonials (schema `class`), and shopify:section:load hands us
     that very element — querySelectorAll only walks descendants, so the scope must be tested too or the slider
     never initialises after a theme-editor edit. */
  function boot(scope) {
    var root = scope || document;
    if (root.matches && root.matches('.et-cart-testimonials')) init(root);
    root.querySelectorAll('.et-cart-testimonials').forEach(init);
  }

  function teardown(scope) {
    var root = scope || document;
    var destroy = function (el) {
      if (el.etSwiper) {
        el.etSwiper.destroy(true, true);
        el.etSwiper = null;
      }
    };
    if (root.matches && root.matches('.et-cart-testimonials')) destroy(root);
    root.querySelectorAll('.et-cart-testimonials').forEach(destroy);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    teardown(event.target);
  });
})();
